var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modules-settings-vendor-detail" },
    [
      _c(
        "div",
        {
          staticClass: "nav-section",
          class: { "no-border-top": !_vm.isContractor },
        },
        [
          _c(
            "a",
            {
              staticClass: "nav-back",
              on: {
                click: function ($event) {
                  return _vm.navToVendorTab()
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("back")) + "\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "company-info" }, [
        !_vm.isContractor
          ? _c("div", { staticClass: "vendor-number" }, [
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("settings.user.vendor.number")) + ": "
                ),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.companyInfo.id))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("label", { staticClass: "emphasis sub-title" }, [
          _vm._v(_vm._s(_vm.$t("settings.user.vendor.companyDetail"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "small-6 medium-6 large-6 columns" }, [
            _c("p", [_vm._v(_vm._s((_vm.companyInfo || {}).name))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s((_vm.companyInfo || {}).address1))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s((_vm.companyInfo || {}).address2))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s((_vm.companyInfo || {}).address3))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s((_vm.companyInfo || {}).address4))]),
          ]),
          _vm._v(" "),
          !_vm.isContractor
            ? _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.specialHandled,
                      expression: "specialHandled",
                    },
                    { name: "hkldinput", rawName: "v-hkldinput" },
                  ],
                  class: { disabled: !_vm.editView },
                  attrs: {
                    id: "settings-users-contractor-company-name-update",
                    type: "checkbox",
                    disabled: !_vm.editView,
                  },
                  domProps: {
                    checked: Array.isArray(_vm.specialHandled)
                      ? _vm._i(_vm.specialHandled, null) > -1
                      : _vm.specialHandled,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.specialHandled,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.specialHandled = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.specialHandled = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.specialHandled = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    attrs: {
                      for: "settings-users-contractor-company-name-update",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("settings.user.vendor.combineName")))]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "emphasis" }, [
          _vm._v(" " + _vm._s(_vm.$t("settings.user.vendor.phone"))),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm._f("isEmptyValue")((_vm.companyInfo || {}).phone))),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "HKLCollapse",
        {
          staticClass: "user-management",
          attrs: {
            title: _vm.$t("userManagement.title"),
            keepContentAlive: true,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "vendor-user-management",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c(
                "form",
                {
                  attrs: {
                    id: "vendor-detail-form",
                    "data-abide": "",
                    novalidate: "",
                  },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "contract-detail" },
                    [
                      _vm.departmentNames.length > 0
                        ? _c("TabsBar", {
                            attrs: {
                              tabNames: _vm.departmentNames,
                              getCurrentTab: _vm.refreshCurrentContractorDetail,
                              disableSwitch: _vm.editView,
                              disabledTabs: [],
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "invited-and-button row" }, [
                        !_vm.isContractor && _vm.departmentNames.length > 0
                          ? _c(
                              "div",
                              { staticClass: "login-invited-info columns" },
                              [
                                _c("div", { staticClass: "last-login" }, [
                                  _c("span", { staticClass: "emphasis" }, [
                                    _vm._v(_vm._s(_vm.$t("lastLogin")) + ": "),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("isEmptyValue")(_vm.lastLoginAt)
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "invited-at" }, [
                                  _c("span", { staticClass: "emphasis" }, [
                                    _vm._v(_vm._s(_vm.$t("invitedAt")) + ": "),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("isEmptyValue")(_vm.invitedAt)
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showButtons
                          ? _c("div", { staticClass: "columns" }, [
                              _c(
                                "div",
                                { staticClass: "row action-bar" },
                                [
                                  !_vm.isContractor && !_vm.editView
                                    ? _c("HKLButton", {
                                        attrs: {
                                          color: "darkblue",
                                          action: "sendInvitation",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.sendInvitation()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.editView
                                    ? _c("HKLButton", {
                                        attrs: {
                                          color: "orange",
                                          action: "edit",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.editView = true
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.editView
                                    ? _c("HKLButton", {
                                        directives: [
                                          {
                                            name: "hkldreset",
                                            rawName: "v-hkldreset",
                                          },
                                        ],
                                        attrs: {
                                          color: "darkblue",
                                          action: "cancel",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.discardChange()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.editView
                                    ? _c("HKLButton", {
                                        directives: [
                                          {
                                            name: "hkldreset",
                                            rawName: "v-hkldreset",
                                          },
                                        ],
                                        attrs: {
                                          color: "orange",
                                          action: "save",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.save()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "emphasis sub-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("settings.user.vendor.adminDetail"))
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isContractor
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "small-4 medium-4 large-4 columns",
                              },
                              [
                                _c("label", { staticClass: "emphasis" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("settings.user.vendor.userType")
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("userType.contractorAdmin"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emphasis",
                                    class: { "required-flag": _vm.editView },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "settings.user.vendor.userStatus"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("HKLSelect", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.editView,
                                      expression: "editView",
                                    },
                                  ],
                                  class: _vm.vendorStatusErrClass,
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    id: "settings-users-contractor-detail-multiselect",
                                    value: _vm.status,
                                    options: _vm.statusHklOptions,
                                    showSearch: false,
                                    placeholder: "",
                                  },
                                  on: {
                                    change: function (val) {
                                      _vm.status = val
                                      _vm.validate()
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.editView,
                                        expression: "!editView",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.status) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "small-4 medium-4 large-4 columns" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "emphasis",
                                class: { "required-flag": _vm.editView },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "settings.user.vendor.contactAdminName"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("HKLInput", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.editView,
                                  expression: "editView",
                                },
                                { name: "hkldinput", rawName: "v-hkldinput" },
                                {
                                  name: "fusioninputcheck",
                                  rawName: "v-fusioninputcheck",
                                  value: {
                                    type: "string",
                                    required: true,
                                  },
                                  expression:
                                    "{\n                  type: 'string',\n                  required: true,\n                }",
                                },
                              ],
                              staticClass: "hkl-input-with-95",
                              attrs: { type: "text", required: "" },
                              on: { change: _vm.validate },
                              model: {
                                value: _vm.contactAdminName,
                                callback: function ($$v) {
                                  _vm.contactAdminName = $$v
                                },
                                expression: "contactAdminName",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.editView,
                                    expression: "!editView",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.contactAdminName) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.enableWorkPermitsFeature
                          ? _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emphasis",
                                    class: { "required-flag": _vm.editView },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "settings.user.vendor.swpVendors"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("HKLSelect", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.editView,
                                      expression: "editView",
                                    },
                                  ],
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    id: "settings-users-contractor-detail-multiselect-swp",
                                    value: _vm.swpEnabled,
                                    options: _vm.swpHklOptions,
                                    showSearch: false,
                                    placeholder: "",
                                  },
                                  on: { change: _vm.updateSwpPerms },
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.editView,
                                        expression: "!editView",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formatBooleanValue(_vm.swpEnabled)
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "label",
                          {
                            staticClass: "emphasis",
                            class: { "required-flag": _vm.editView },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("settings.user.vendor.phone")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.editView,
                              expression: "editView",
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.contactPhoneNum,
                              expression: "contactPhoneNum",
                            },
                            { name: "hkldinput", rawName: "v-hkldinput" },
                            {
                              name: "fusioninputcheck",
                              rawName: "v-fusioninputcheck",
                              value: {
                                type: "string",
                                pattern: _vm.regex.phone,
                                tip: _vm.tips.phone,
                              },
                              expression:
                                "{\n                type: 'string',\n                pattern: regex.phone,\n                tip: tips.phone\n              }",
                            },
                          ],
                          attrs: { type: "text", required: "" },
                          domProps: { value: _vm.contactPhoneNum },
                          on: {
                            change: _vm.validate,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.contactPhoneNum = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.editView,
                                expression: "!editView",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.contactPhoneNum) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isContractor
                        ? _c(
                            "div",
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "emphasis",
                                  class: { "required-flag": _vm.editView },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("username")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("HKLInput", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.editView,
                                    expression: "editView",
                                  },
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                  {
                                    name: "fusioninputcheck",
                                    rawName: "v-fusioninputcheck",
                                    value: {
                                      type: "string",
                                      tip: _vm.usernameTip,
                                      pattern: _vm.validateUsername,
                                      required: true,
                                    },
                                    expression:
                                      "{\n                type: 'string',\n                tip: usernameTip,\n                pattern: validateUsername,\n                required: true\n              }",
                                  },
                                ],
                                staticClass: "hkl-input-with-95",
                                class: _vm.usernameErrClass,
                                attrs: {
                                  type: "text",
                                  pattern: "email",
                                  required: "",
                                },
                                on: { change: _vm.validate },
                                model: {
                                  value: _vm.username,
                                  callback: function ($$v) {
                                    _vm.username = $$v
                                  },
                                  expression: "username",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.editView,
                                      expression: "!editView",
                                    },
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.username) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isContractor
                        ? _c(
                            "div",
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "emphasis",
                                  class: { "required-flag": _vm.editView },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("settings.user.vendor.email")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("HKLInput", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.editView,
                                    expression: "editView",
                                  },
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                  {
                                    name: "fusioninputcheck",
                                    rawName: "v-fusioninputcheck",
                                    value: {
                                      type: "string",
                                      required: true,
                                    },
                                    expression:
                                      "{\n                type: 'string',\n                required: true\n              }",
                                  },
                                ],
                                staticClass: "hkl-input-with-95",
                                attrs: {
                                  type: "text",
                                  pattern: "email",
                                  required: "",
                                },
                                on: { change: _vm.validate },
                                model: {
                                  value: _vm.emailAddress,
                                  callback: function ($$v) {
                                    _vm.emailAddress = $$v
                                  },
                                  expression: "emailAddress",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.editView,
                                      expression: "!editView",
                                    },
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.emailAddress) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("div", { staticClass: "reset-password" }, [
                                _c("label", { staticClass: "emphasis" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "settings.user.vendor.loginEmail"
                                        )
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "inline-text" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.username) +
                                      "\n              "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.isContractorAdmin
                                ? _c(
                                    "HKLButton",
                                    {
                                      staticClass: "reset-link",
                                      attrs: {
                                        action: "reset-link",
                                        color: "orange",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.navToResetPwd()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$i18n.t(
                                              "settings.password.resetYourPassword"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("VendorSubAccounts", { ref: "vendorSubAccounts" }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("VendorContacts"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }